import cx from "classnames";
import React from "react";
import { useSelector } from "react-redux";

import { Column, Container, PageBannerManager, Row } from "@gamedev-web/gamedev-sdk-core";

import { getCurrentError } from "../../redux/selectors";
import * as commonStyles from "../commonStyles/commonStyles.module.css";
import * as styles from "./ErrorBanner.module.css";

const getStack = (stackString: string): string[] => stackString.toString().split("\n");

export const ErrorBanner = () => {
  const error = useSelector(getCurrentError);

  if (!error) {
    return null;
  }

  const onCloseClick = () => {
    PageBannerManager.hideAllBanners();
  };

  return (
    <Container className={cx(commonStyles.pageContainer, styles.wrapper)}>
      <Row>
        <Column>
          <p className={styles.devOnlyTitle}>{"Dev only: "}</p>
          {error.message && <p>{`${error.message}`}</p>}{" "}
          {error.stack && (
            <>
              {getStack(error.stack).map((stackLine, index) => (
                <p key={`stack-${index}`}>{`${stackLine}`}</p>
              ))}
            </>
          )}
          <button onClick={onCloseClick}>Close</button>
        </Column>
      </Row>
    </Container>
  );
};
